export default __webpack_public_path__ + "static/SubpageBanners_Orthodontics-5cee1c88e1f5db8c02691f96f94da424.jpg";